import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entregas-parciales',
  templateUrl: './entregas-parciales.component.html',
  styleUrls: ['./entregas-parciales.component.css']
})
export class EntregasParcialesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
